import React, { useReducer, createContext, useContext } from "react";
import { reducer, initialHousesState } from "./reducer";

export const HousesContext = createContext();
export const useHousesContext = () => useContext(HousesContext);

export const DriversProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialHousesState);

  return (
    <HousesContext.Provider value={[state, dispatch]}>
      {children}
    </HousesContext.Provider>
  );
};
